export enum contactTypeTypes {
  GROUP_HOME = 'groupHome',
  PROFILE = 'profile',
}
